import { faCode, faUsers } from "@fortawesome/free-solid-svg-icons";
import { TechnologiesComponent } from "../components/TechnologiesComponent";

const technicalSkills = [
    "TypeScript",
    "React",
    "React Native",
    "TanStack Query",
    "Go",
    "Tailwind",
    "PostgreSQL",
    "Angular",
    "Vue",
    "Java",
    "Spring Boot",
    "iOS",
    "Android",
];

const softSkills = [
    "Communication",
    "Problem solving",
    "Ownership",
    "Accountability",
    "Time management",
    "Remote collaboration",
    "Project planning",
    "Leadership",
    "Mentoring",
];

export const Skills = () => {
    return <div className="w-11/12 md:w-5/6 xl:w-1/2 m-auto">
        <TechnologiesComponent title="TECHNICAL SKILLS" icon={faCode} skills={technicalSkills}/>
        <TechnologiesComponent title="SOFT SKILLS" icon={faUsers} skills={softSkills}/>
    </div>;
}
